import { render } from "./Archive_products.vue?vue&type=template&id=7d65571a"
import script from "./Archive_products.vue?vue&type=script&lang=js"
export * from "./Archive_products.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__